import React, { useState,useEffect } from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "react-datepicker/dist/react-datepicker.css";
import ActiveBillDetailPage from "./ActiveBillPaymentDetails"; 
import CommonAPI from '../../Common/CommonAPI';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import FadeLoader from "react-spinners/HashLoader"; 
import moment from 'moment';
import { Table } from 'react-bootstrap';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import downloadpng from "../../images/download.png";

function  ActiveBillPayments(props)  { 
    
    const [BillList,setBillList] = useState([]);
    const [SuccessLoading,setSuccessLoading] = useState(false);
    const [BillActiveDetail,setBillActiveDetail] = useState(false);
    const [ SuccessDownload,setSuccessDownload] = useState(false);
    useEffect( () => { 
        ActiveBillPaymentsAPI();
      },[])  ;

      const ActiveBillPaymentsAPI =  (val)=>{
        setSuccessLoading(true)
        CommonAPI2.ActiveBillPayments((results) =>{   
            if( results){                    
                setBillList(results.sort((a,b)=>{var x = a.dueDate; var y = b.dueDate;
                    return ((x < y) ? 1 : ((x > y) ? -1 : 0));})) 
                setSuccessLoading(false);                           
            }
            if(results.message==="Invalid Request!"){
                setSuccessLoading(false);    
                console.log("Invalid Request!");
              }
        });
    }
    const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

      const BillDetails = (ind)=>{
        var BillInfor = {
          BillRef: ind.id,
          BillReference:ind.billRef,
          BillDueDate:ind.dueDateMilli,
        }
        var value = JSON.stringify(BillInfor);
        sessionStorage.setItem('BillValues', value );
        setBillActiveDetail(true)
      }

      const BillActiveDetailToggleModal = () => {
        setBillActiveDetail(!BillActiveDetail);
        ActiveBillPaymentsAPI();
    }

    const printDocument =()=>{
        return (
        <Modal
            size="lg"
            centered         
            onHide={()=>setSuccessDownload(!SuccessDownload)}       
            aria-labelledby="contained-modal-title-vcenter"        
            backdrop="static"
            show={SuccessDownload}> 
    
         <Modal.Header closeButton>
            <Modal.Title className='hselect' id="contained-modal-title-vcenter">
            <p className='modal-head-f'>ACTIVE</p><br/>BILL PAYMENT
            </Modal.Title>
            <div>
                <img className='downlogo' onClick ={DownloadDocument.bind(this)} src={downloadpng} alt="download" />
            </div>
          </Modal.Header>
          
          <Modal.Body>
                    
                <Row lg={12} className='div-background'>
                    <Col lg={12} className='rmv-pad3 block text-color'>
    
                    <Table  id="divToPrint" hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width5'>No</th>
                            <th className='td-width5'>Reference Number</th>
                            <th className='td-width5'>Next Pay Date</th>
                            <th className='td-width5'>Frequency</th>
                            <th className='td-width5'>Pay End</th>
                            <th className='td-width5'>Last Paid / Pay Status</th>
                            <th className='td-width5' >Service Provider</th>
                            <th className='td-width5'> Amount LKR</th>
                            <th className='td-width5'>Billing Account</th>
                            
                            </tr>
                        </thead>
                        <tbody className='heightTable'>
                        {BillList.length>0?BillList.map(( listValue, index ) => {
                       return( 
                           <tr>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{index + 1} {listValue.recurringPay == "R" ? "**" : " "}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.billRef}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{(listValue.dueDate && listValue.recurringPay == "S") ? moment(listValue.dueDateMilli).format('DD/MM/YYYY') : moment(listValue.dueDate).format('DD/MM/YYYY')}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.frequency == "M" ? "Monthly" : listValue.frequency == "D" ? "Daily" : listValue.frequency == "W" ? "Weekly" : listValue.frequency == "H" ? "Half Yearly" : listValue.frequency == "Y" ? "Yearly" : listValue.frequency == "Q" ? "Quarterly" : "-"}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{(listValue.recurringPay == "R" && !listValue.endDate) ? "U.F.N" : (listValue.dueDate && listValue.recurringPay == "S") ? moment(listValue.dueDateMilli).format('DD/MM/YYYY') : (listValue.endDate ? moment(listValue.endDate).format('DD/MM/YYYY') : "-")}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.lastPayDate ? moment(listValue.lastPayDate).format('DD/MM/YYYY') : "-"}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.provider}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.payAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top'>{listValue.accountNo}</p>
                               </td>
                               
                           </tr>
                       )
                        }):
                        <tr  className='tr-h'>
                            <td colspan="9"><p className='t-center block-top'>No Records</p></td>
                        </tr> 
                    } 
                        </tbody>
                    </Table>
                    </Col>
                </Row>
            
        </Modal.Body>        
        </Modal>
            );
        }

    const DownloadDocument =()=> {
        
        const input = document.getElementById('divToPrint');
        html2canvas(input)
          .then((canvas) => {
            var imgWidth = 210;
            var pageHeight = 295;
            var imgHeight = canvas.height * imgWidth / canvas.width;
            var heightLeft = imgHeight;
            var position = 0;
  
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', [290, 210]);
            pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                 position = heightLeft - imgHeight;
                 pdf.addPage();
                 pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                 heightLeft -= pageHeight;
               }
            //pdf.output('dataurlnewwindow');
            pdf.save("ActiveBillPayments.pdf");
          })
        ;
       }
      if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }
        return (

            <div>
                {SuccessDownload?printDocument():null}
                <Row className='block'>
                    <Col sm={6} className="d-flex align-items-center ">
                     <p className='p-line2'>ACTIVE BILL PAYMENTS</p>
                    </Col>  
                    <Col sm={6} className="d-flex align-items-center justify-content-end" >                                
                        <img className='downlogo' 
                        onClick ={()=>setSuccessDownload(true)} 
                        src={downloadpng} alt="download" />
                    </Col> 
                </Row>
                {BillActiveDetail?
                <ActiveBillDetailPage isOpen={BillActiveDetail} toggle={BillActiveDetailToggleModal} />
                :null
                }
                <Table   hover responsive>
                        <thead >
                            <tr>
                            <th className='td-width9 t-left'>No<p></p></th>
                            <th className='td-width5 t-left'>Reference <br/>Number</th>
                            <th className='td-width5 t-left'>Next Pay <br/>Date</th>
                            <th className='td-width5 t-left'>Frequency<p></p></th>
                            <th className='td-width9 t-left'>Pay <br/>End</th>
                            <th className='td-width5 t-right'>Last Paid / Pay Status</th>
                            <th className='td-width5 t-right' >Service <br/>Provider</th>
                            <th className='td-width5 t-right'> Amount<br/> LKR</th>
                            <th className='td-width5 t-right'>Billing<br/> Account</th>
                            <th className='td-width5 t-right'> Details / Cancel Payment </th>
                            
                            </tr>
                        </thead>
                        <tbody >
                        {BillList.length>0?BillList.map(( listValue, index ) => {
                       return( 
                           <tr>
                               <td className='td-width9'>
                                   <p className='tb-text m-top t-left'>{index + 1} {listValue.recurringPay == "R" ? "**" : " "}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-left'>{listValue.billRef}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-left'>{(listValue.dueDate && listValue.recurringPay == "S") ? moment(listValue.dueDateMilli).format('DD/MM/YYYY') : moment(listValue.dueDate).format('DD/MM/YYYY')}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-left'>{listValue.frequency == "M" ? "Monthly" : listValue.frequency == "D" ? "Daily" : listValue.frequency == "W" ? "Weekly" : listValue.frequency == "H" ? "Half Yearly" : listValue.frequency == "Y" ? "Yearly" : listValue.frequency == "Q" ? "Quarterly" : "-"}</p>
                               </td>
                               <td className='td-width9'>
                                   <p className='tb-text m-top t-left'>{(listValue.recurringPay == "R" && !listValue.endDate) ? "U.F.N" : (listValue.dueDate && listValue.recurringPay == "S") ? moment(listValue.dueDateMilli).format('DD/MM/YYYY') : (listValue.endDate ? moment(listValue.endDate).format('DD/MM/YYYY') : "-")}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-right'>{listValue.lastPayDate ? moment(listValue.lastPayDate).format('DD/MM/YYYY') : "-"}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-right'>{listValue.provider}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-right'>{listValue.payAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                               </td>
                               <td className='td-width5'>
                                   <p className='tb-text m-top t-right'>{listValue.accountNo}</p>
                               </td>
                               <td className='td-width5 t-right'>
                                   <Button
                                       onClick={() => { BillDetails(listValue) }}
                                       className='btn-browse'
                                       variant="primary" type="submit">
                                       Details
                                   </Button>
                               </td>
                           </tr>
                       )
                        }):
                        <tr  className='tr-h'>
                            <td colspan="10"><p className='t-center block-top'>No Records</p></td>
                        </tr> 
                    } 
                        </tbody>
                </Table>
            
               
                    <div className='d-flex flex-column align-items-start block'>
                    <p className='tb-text t-left'>** - Reccuring Bill Payments</p>
                    <p className='tb-text t-left'>U.F.N - Until Further Notice</p>
                    <p className='tb-text s-top '>W - Standing Orders Done through Web</p>   
                    </div>  
            </div>
          );
    }

export default ActiveBillPayments;